module.exports = __webpack_public_path__ + "fc821c53dd263ffb52042aeed389fa89.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Light.eot
// module id = 392
// module chunks = 0